var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 2.16634L1.99967 2.17467M1.99967 7.99967L1.99967 8.00801M1.99967 13.833L1.99967 13.8413M1.99967 2.99967C1.53944 2.99967 1.16634 2.62658 1.16634 2.16634C1.16634 1.7061 1.53944 1.33301 1.99967 1.33301C2.45991 1.33301 2.83301 1.7061 2.83301 2.16634C2.83301 2.62658 2.45991 2.99967 1.99967 2.99967ZM1.99967 8.83301C1.53944 8.83301 1.16634 8.45991 1.16634 7.99967C1.16634 7.53944 1.53944 7.16634 1.99967 7.16634C2.45991 7.16634 2.83301 7.53944 2.83301 7.99967C2.83301 8.45991 2.45991 8.83301 1.99967 8.83301ZM1.99967 14.6663C1.53944 14.6663 1.16634 14.2932 1.16634 13.833C1.16634 13.3728 1.53944 12.9997 1.99967 12.9997C2.45991 12.9997 2.83301 13.3728 2.83301 13.833C2.83301 14.2932 2.45991 14.6663 1.99967 14.6663Z",
    stroke: "#9BA1A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon5);
export default __webpack_public_path__ + "static/media/application-icon-5.482447abc8dcc979ea962663ef449393.svg";
export { ForwardRef as ReactComponent };